export const formatRUT = (value) => {
    if (!value) return '';
    const clean = value.replace(/[.\-]/g, '').toUpperCase();
    if (clean.length < 2) return clean;
    return clean.slice(0, -1) + '-' + clean.slice(-1);
};

export const isValidRUTFormat = (rut) => {
    if (!rut) return false;
    if (rut.includes('.')) return false;
    const dashIndex = rut.lastIndexOf('-');
    return dashIndex === rut.length - 2 && dashIndex > 0;
};
